<template>
  <v-col>
    <v-row>
      <calcolatori
        :article="article"
        kind="smartphone"
      />
    </v-row>
    <v-row justify="end">
      <v-btn
        color="primary"
        class="mt-6"
        @click="downloaGiacenza"
      >Scarica XLS Giacenze</v-btn>
    </v-row>
    <br>
    <v-row>
      <v-card style="width: 100%">
        <v-card-title class="pb-8">
          <v-btn
            color="primary"
            @click="CHANGE_CELLULARI_COMPONENT('Insert')"
          >Nuovo Smartphone</v-btn>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Cerca"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="cellulari"
          class="elevation-1"
          :search="search"
          :items-per-page="100"
          :footer-props="{
            itemsPerPageAllText: 'Tutti',
            itemsPerPageOptions: [15, 50, 100, -1],
            itemsPerPageText: 'Cellulari per pagina',
          }"
          @click:row="rowClickHandler"
        >
          <template v-slot:top>
            <edit-form
              :item="selectedItem"
              @edit-submit="triggerSnack($event)"
            />
          </template>

          <template v-slot:item.action="{ item }">
            <td class="actions">
              <v-btn
                color="orange"
                elevation="1"
                outlined
                small
                @click.stop="edit(item)"
              >
                <v-icon small>
                  mdi-pencil
                </v-icon>
              </v-btn>
              <v-btn
                color="red"
                elevation="1"
                outlined
                small
                @click.stop="triggerDialog(item)"
              >
                <v-icon small>
                  mdi-delete
                </v-icon>
              </v-btn>
            </td>
          </template>

          <template v-slot:no-data>
            <v-btn
              color="primary"
              @click="fetchCellulari"
            >Ricarica</v-btn>
          </template>

          <template v-slot:item.is_art_17="{ item }">
            <span v-if="item.is_art_17 === 1">{{'Art.17'}}</span>
            <span v-else>{{'Art.36'}}</span>
          </template>

          <template v-slot:item.cost="{ item }">
            <span>{{item.cost || '0'}}€</span>
          </template>

          <template v-slot:item.price="{ item }">
            <span>{{item.price || '0'}}€</span>
          </template>

          <template v-slot:item.posix="{ item }">
            <span>{{new Date(item.posix).toLocaleString('it-IT', {'day': '2-digit', 'month': '2-digit', 'year': 'numeric', })}}</span>
          </template>
        </v-data-table>

        <snack-notification :snack="snack" />
      </v-card>
    </v-row>

    <!-- dialog -->

    <v-row justify="center">
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
          <v-card-title class="headline">Cancellare articolo?</v-card-title>

          <v-card-text>
            Confermando, il prodotto selezionato verrà eliminato dal magazzino.
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>

            <v-btn
              color="primary"
              text
              @click="remove()"
            >
              Conferma
            </v-btn>

            <v-btn
              color="primary"
              @click="dialog = false"
            >
              Annulla
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>
  </v-col>
</template>

<script>
  import axios from 'axios'
  import { mapMutations } from 'vuex'

  import Calcolatori from './../../dashboard/tools/Calcolatori'
  import EditForm from './EditForm'
  import SnackNotification from './../../SnackNotification'

  export default {
    name: 'Index',
    components: {
      Calcolatori,
      EditForm,
      SnackNotification
    },
    data: () => ({
      today: `${(new Date()).getDate()}-${(new Date()).getMonth() + 1}-${(new Date()).getFullYear()}`,
      search: '',
      dialog: false,
      headers: [
        { text: 'Fornitore', value: 'supplier_name', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'IMEI', value: 'serial_number', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'EAN', value: 'ean', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Brand', value: 'brand', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Modello', value: 'model', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Colore', value: 'color', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'HDD', value: 'disk_space', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'RAM', value: 'ram', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Grado', value: 'grade', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Regime', value: 'is_art_17', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Descrizione', value: 'desctiption', class: 'subtitle-2 primary--text font-weight-bold', width: '400px' },
        { text: 'Costo', value: 'cost', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Prezzo', value: 'price', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: 'Acquistato il', value: 'posix', class: 'subtitle-2 primary--text font-weight-bold' },
        { text: '', value: 'action', class: 'subtitle-2 primary--text font-weight-bold', sortable: 'false' }
      ],
      cellulari: [],
      item: {},
      snack: {
        error: null,
        visible: null,
        message: null
      },
      config: {
        headers: {
          'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
        }
      },
      row: {
        articolo: '17',
        pagato: '',
        ricarico: '',
        pap: '',
        iva: '',
        utile: '',
        incassato: '',
        rate: '',
        utileFinale: '',
        costoRate: '',
        rata: '',
        incidenza: '',
        dilapay: {
          fisso: '',
          variabile: ''
        }
      }
    }),

    computed: {
      selectedItem() {
        return this.item
      },
      article() {
        return this.row
      }
    },

    methods: {
      ...mapMutations([
        'CHANGE_CELLULARI_COMPONENT',
        'CHANGE_CELLULARI_EDIT'
      ]),

      async fetchCellulari() {
        try {

          let {
            data
          } = await axios.get(`${process.env.VUE_APP_API}/smartphones/fetch`, this.config)

          this.cellulari = data
        } catch (error) {

          console.log(error)

          this.cellulari = []
        }
      },

      async downloaGiacenza() {
        let { data } = await axios.get(`${process.env.VUE_APP_API}/downloads/giacenza-smartphones`, this.config)

        var fileURL = window.URL.createObjectURL(new Blob([data]))
        var fileLink = document.createElement('a')

        const name = `[${this.today}]report_giacenze_smartphones.xls`

        fileLink.href = fileURL
        fileLink.setAttribute('download', name)
        document.body.appendChild(fileLink)

        fileLink.click()
      },

      //

      rowClickHandler(data) {
        console.log('data:', data)

        this.row = {
          id: data.id,
          articolo: data.is_art_17 === 0 ? '36' : '17',
          pagato: data.cost,
          ricarico: '',
          pap: data.price,
          iva: '',
          utile: '',
          incassato: '',
          rate: '',
          utileFinale: '',
          costoRate: '',
          rata: '',
          incidenza: '',
          dilapay: {
            fisso: '',
            variabile: ''
          }
        }
      },

      edit(val) {
        this.item = val
        this.CHANGE_CELLULARI_EDIT(true)
      },

      async remove() {

        const { data } = await axios.post(`${process.env.VUE_APP_API}/smartphones/delete`, this.item, this.config)

        if (data.status) {
          this.fetchCellulari()
          this.dialog = false
        } else {
          alert('Si è verificato un errore.')
        }
      },

      triggerDialog(val) {
        this.item = val
        this.dialog = true
      },

      triggerSnack(e) {
        if (e === 'reset') {

          this.snack = Object.assign({}, {
            error: null,
            visible: null,
            message: null
          })
        } else if (e === 'ok') {

          this.snack = Object.assign({}, {
            visible: true,
            error: false,
            message: 'Articolo modificato correttamente!'
          })
        } else if (e === 'error') {

          this.snack = Object.assign({}, {
            visible: true,
            error: true,
            message: 'Errore nella modifica.'
          })
        }
      }
    },

    async created() {
      await this.fetchCellulari()
    },
  }
</script>

<style>
  .actions {
    display: flex;
    flex-flow: row;
    justify-content: flex-end;
    align-items: center;
  }

  .actions > button {
    margin-left: 10px;
  }
</style>